module.exports = __webpack_public_path__ + "static/img/logo_igprog.d5efc8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_igprog.png
// module id = uqS8
// module chunks = 0